import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import styled, {css} from 'styled-components'

export const StyledAgendaToolbar = styled.div(
    ({theme: {spacing, palette}}) => css`
        display: grid;
        grid-template-columns: 1fr auto 1fr;
        gap: ${spacing * 2}px;
        height: 64px;
        align-items: center;
        padding: 0 ${spacing * 4}px;
        background-color: ${palette.neutral['white']};
        border-bottom: 1px solid ${palette.neutral['200']};
    `
)

export const StyledCurrentDateTitle = styled.b(
    ({theme: {typography}}) => css`
        font-size: ${typography.textMd};
        font-weight: 500;
        text-transform: capitalize;
    `
)

export const StyledAgendaToolbarOptions = styled(Flexbox)`
    & button {
        white-space: nowrap;
    }
`
